import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin":"80px"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("AES加密")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("AES解密")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("BASE64编码")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("BASE64解码")
const _hoisted_6 = ["textContent"]

import { ref } from "vue";
import CryptoJS from "crypto-js";
import { AES_KEY, AES_IV } from "@/request/config";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const resultText = ref("");
const inputText = ref("");
const encodeAES = () => {
  resultText.value = CryptoJS.enc.Base64.stringify(
    CryptoJS.AES.encrypt(inputText.value, CryptoJS.enc.Utf8.parse(AES_KEY), {
      mode: CryptoJS.mode.CBC,
      iv: CryptoJS.enc.Utf8.parse(AES_IV),
      padding: CryptoJS.pad.Iso10126,
    }).ciphertext
  );
};
const decodeAES = () => {
  resultText.value = CryptoJS.AES.decrypt(
    CryptoJS.enc.Base64.stringify(CryptoJS.enc.Base64.parse(inputText.value)),
    CryptoJS.enc.Utf8.parse(AES_KEY),
    {
      mode: CryptoJS.mode.CBC,
      iv: CryptoJS.enc.Utf8.parse(AES_IV),
      padding: CryptoJS.pad.Iso10126,
    }
  )
    .toString(CryptoJS.enc.Utf8)
    .toString();
};
const encodeBase64 = () => {
  resultText.value = CryptoJS.enc.Base64.stringify(
    CryptoJS.enc.Utf8.parse(inputText.value)
  ).toString();
};
const decodeBase64 = () => {
  resultText.value = CryptoJS.enc.Base64.parse(inputText.value).toString(
    CryptoJS.enc.Utf8
  );
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_input, {
      type: "textarea",
      modelValue: inputText.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputText).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_button, { onClick: encodeAES }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, { onClick: decodeAES }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, { onClick: encodeBase64 }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, { onClick: decodeBase64 }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      textContent: _toDisplayString(resultText.value)
    }, null, 8, _hoisted_6)
  ]))
}
}

})